import React, { useState, useEffect } from 'react';
import { css } from '@emotion/core';
import { Menu, MenuItem, IconButton, Tooltip } from '@material-ui/core';
import { Observer } from 'mobx-react';
import InvalidIcon from '@material-ui/icons/Warning';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { Link } from 'react-router-dom';
import { getColorByState } from '../../../../stores/dealMapperStore/dealMapUtil';
import { FlexDiv } from '../../../styles/styles';
import { useRootStore } from '../../../../stores/BridgeProvider';
import DealModal from './DealModal';
import Cell from '../../common/Cell';
import DealTransaction from './DealTransaction';
import NewDealTransactionModal from './NewDealTransactionModal';
import RenderPropModal from '../../common/RenderPropModal';
import { COLORS } from '../../../util/Colors';
import { DealSchema } from '../../../../validation';

const headerStyle = css`
  background: ${COLORS.blue};
  // background: #006eb5;
  color: ${COLORS.white};
  height: 55px;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  h4 {
    margin: 0px;
  }
`;

const headerInfoBlock = css`
  display: flex;
  flex: 1;
  justify-content: space-between;
  margin-right: 2px;
`;

// TODO
const DealCell = ({ original }) => (
  <Observer
    render={() => {
      const { dealMapperStore } = useRootStore();
      const [validationErrors, setValidationErrors] = useState(null);
      const [anchorEl, setAnchorEl] = React.useState(null);

      const handleMenuClick = event => {
        setAnchorEl(event.currentTarget);
      };

      const handleMenuClose = () => {
        setAnchorEl(null);
      };

      const color = getColorByState(original);
      const {
        DealId,
        dealTransactions,
        Title,
        TransactionDate,
        Seed,
        Pending,
      } = original;
      useEffect(() => {
        let unmounted = false;
        const checkValidity = async () => {
          try {
            await DealSchema.validate(original, {
              abortEarly: false,
            });
            if (validationErrors) setValidationErrors(null);
          } catch (e) {
            if (!unmounted) {
              setValidationErrors(e.errors);
            }
          }
        };

        checkValidity();
        return () => {
          unmounted = true;
        };
      }, [original]);

      const titleTrim = () => {
        if (!Title) return '';
        return Title.length > 28 ? `${Title.slice(0, 28)}...` : Title;
      };

      return (
        <RenderPropModal
          manageHandleOpen
          cardDisplay={({ handleClose }) => (
            <FlexDiv>
              <DealModal dealId={DealId} handleClose={handleClose} />
            </FlexDiv>
          )}
          enterHover={() => {
            dealMapperStore.dealMapperViewStore.setHoveredElement(original);
          }}
          exitHover={() => {
            dealMapperStore.dealMapperViewStore.setHoveredElement(null);
          }}
        >
          {() => (
            <Cell cellObject={original}>
              <div css={headerStyle}>
                <div css={headerInfoBlock}>
                  <h4>{titleTrim()}</h4>
                  <span>{TransactionDate}</span>
                </div>
                {validationErrors && (
                  <Tooltip
                    title={
                      <ul style={{ padding: 0, listStyleType: 'none' }}>
                        {validationErrors.map(error => (
                          <li key={error}>* {error}</li>
                        ))}
                      </ul>
                    }
                  >
                    <InvalidIcon
                      style={{
                        color: COLORS.red,
                      }}
                    />
                  </Tooltip>
                )}
                <div onClick={e => e.stopPropagation()}>
                  <IconButton
                    onClick={handleMenuClick}
                    style={{ color: 'white' }}
                  >
                    <MoreVertIcon />
                  </IconButton>
                  <RenderPropModal
                    cardDisplay={({ handleClose }) => (
                      <NewDealTransactionModal
                        deal={original}
                        handleClose={handleClose}
                      />
                    )}
                  >
                    {({ handleOpen }) => (
                      <Menu
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleMenuClose}
                      >
                        <MenuItem
                          onClick={e => {
                            handleOpen(e);
                            handleMenuClose();
                          }}
                        >
                          New Transaction
                        </MenuItem>
                        {!Pending && (
                          <MenuItem
                            disabled={
                              !DealId || dealMapperStore.isAnythingPending
                            }
                            onClick={() => {
                              dealMapperStore.unloadDeal(original);
                              handleMenuClose();
                            }}
                          >
                            Unload Deal
                          </MenuItem>
                        )}
                        {Pending && (
                          <MenuItem
                            onClick={() => {
                              dealMapperStore.removePendingDeal(original);
                              handleMenuClose();
                            }}
                          >
                            Remove Deal
                          </MenuItem>
                        )}
                        {!Pending && (
                          <MenuItem component={Link} to={`/deal/${DealId}`}>
                            Go to Deal
                          </MenuItem>
                        )}
                      </Menu>
                    )}
                  </RenderPropModal>
                </div>
              </div>
              <div style={{ padding: '0rem 0px' }}>
                {dealTransactions.map(dt => (
                  <DealTransaction original={dt} key={dt.DealTranId} />
                ))}
              </div>
            </Cell>
          )}
        </RenderPropModal>
      );
    }}
  />
);

export default DealCell;
